import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { ToastHorizontal, ToastProps, ToastVertical } from './types';

const verticalClasses: Record<ToastVertical, string> = {
  top: 'toast-top',
  middle: 'toast-middle',
  bottom: 'toast-bottom',
};

const horizontalClasses: Record<ToastHorizontal, string> = {
  start: 'toast-start',
  center: 'toast-center',
  end: 'toast-end',
};

export const Toast = forwardRef<HTMLDivElement, ToastProps>(
  ({ className, vertical, horizontal, children, ...props }, ref) => {
    const classes = twMerge(
      'toast',
      vertical ? verticalClasses[vertical] : '',
      horizontal ? horizontalClasses[horizontal] : '',
      className,
    );

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

Toast.displayName = 'Toast';
